import { Map } from 'immutable';

import { getConnectedShopIds } from './getConnectedShopIds';
import { shapeKeywordsForApp } from './shapeAttributes';
import { updateListingScore } from './score';
import { getPublishStatus } from '../listings/statuses';
import { areComplete } from './isComplete';
import { newProduct } from './new';
import { sortShops } from './shapeForApp';
import { getSize } from '../iterable/getSize';

import { PUBLISH_ACTION } from '../../constants/listings';
import { FEATURE } from '../../constants/features';
import { SHOPIFY, EBAY } from '../../constants/channels';
import { EMPTY } from '../../constants';
import { NEW } from '../../constants/product';

function newEdit({ channel, shopId } = {}) {
  return Map({
    channel,
    isComplete: false,
    linkId: null,
    products: EMPTY.MAP,
    productId: NEW,
    shops: EMPTY.LIST,
    shopId,
    title: 'New listing',
  });
}

export function editNewProduct({ data, product, shopId, userFeatures, userShops }) {
  const channel = userShops.getIn(['byId', shopId, 'channel']);
  const isVelaOnlyShop = userShops.getIn(['byId', shopId, 'isVelaOnlyShop']);
  let result = (getSize(data) ? data : newEdit({ channel, shopId }));

  const shops = result
    .get('shops')
    .push(shopId)
    .sort(
      sortShops({
        first: result.get('shopId'),
        prioritized: getConnectedShopIds(result.get('products')),
        sorted: userShops.get('options'),
      })
    );

  result = result
    .set('activeShopId', shopId)
    .set('shops', shops)
    .setIn(['statuses', shopId], getPublishStatus({ action: PUBLISH_ACTION.PUBLISH, channel, isVelaOnlyShop }))
    .setIn(['products', shopId], (product || newProduct({ channel })).set('shopId', shopId));

  if (userFeatures.get(FEATURE.LISTING_SCORE)) {
    if (channel === SHOPIFY || channel === EBAY) {
      result = result.setIn(['products', shopId, 'keywords'], shapeKeywordsForApp());
    }

    const titleFormatPreference = userShops.getIn(['byId', shopId, 'titleFormatPreference']);
    result = result.setIn(['products', shopId], updateListingScore(result.getIn(['products', shopId]), { titleFormatPreference }));
  }

  return result.set('isComplete', areComplete(result.get('products')));
}
